import Vue from "vue";
import Router from "vue-router";

const Login = () => import(/* webpackChunkName: "g1" */ "./views/Login.vue");
const Error = () => import(/* webpackChunkName: "g1" */ "./views/Error.vue");

const Partners = () =>
  import(/* webpackChunkName: "g2" */ "./views/company/Partners.vue");
const Signers = () =>
  import(/* webpackChunkName: "g2" */ "./views/company/Signers.vue");
const Documents = () =>
  import(/* webpackChunkName: "g2" */ "./views/company/Documents.vue");

import MainNavbar from "./layout/MainNavbar.vue";
import CenterNavbar from "./layout/CenterNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

import store from "./store";
import { GetSession, LoadUser } from "./services/localstate";

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "login",
      alias: "/login",
      components: { default: Login },
    },

    {
      path: "/company/partners",
      name: "partners",
      components: {
        default: Partners,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 50, navbarTransparent: true },
        default: true,
      },
      meta: {
        requiresAuth: true,
        role: "12",
      },
    },

    {
      path: "/company/signers",
      name: "signers",
      components: {
        default: Signers,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 50, navbarTransparent: true },
        default: true,
      },
      meta: {
        requiresAuth: true,
        role: "12",
      },
    },

    {
      path: "/company/documents",
      name: "company-documents",
      components: {
        default: Documents,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 50, navbarTransparent: true },
        default: true,
      },
      meta: {
        requiresAuth: true,
        role: "12",
      },
    },

    {
      path: "/logout",
      name: "Logout",
    },
    { path: "*", component: Error },
  ],
  scrollBehavior: (to, from) => {
    if (to.name === from.name) {
      if (to.hash) {
        return { selector: to.hash };
      }
    } else if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const metaauth = to.matched.find((record) => record.meta.requiresAuth);
  if (to.path === "/logout") {
    store.dispatch("logout");
    next({
      path: "/login",
    });

    return;
  }

  if (
    !GetSession() &&
    to.path !== "/login" &&
    to.path.indexOf("/reset") === -1
  ) {
    next({
      path: "/login",
    });
    return;
  }

  if (metaauth !== undefined) {
    let user = store.state.user;
    if (user === null) {
      next({
        name: "login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      if (!user.roleid) {
        user = LoadUser();
      }
      if (metaauth.meta.role.indexOf(user.roleid) !== -1) next();
      else {
        next({
          name: "login",
          params: { nextUrl: to.fullPath },
        });
      }
    }
  } else next();
});

export default router;
